// https://github.com/tighten/ziggy
// https://highlandsolutions.com/blog/how-i-like-to-simplify-ziggys-route-helper

import ZiggyRoute from 'tightenco/ziggy/dist';
var routesList = null;
try {
	let { Ziggy } = require('../generated/ziggyNamedRoutes');
	routesList = Ziggy;
} 
catch (e) { }

export const ziggyGetRoute = (name, params) => {
	if (!routesList) {
		//Ziggy routes could not be found. Make sure to run the artisan command to generate the js/ziggy.js file.
		return null;
	}
	try {
		return ZiggyRoute(name, params, false, routesList);
	} catch {
		return ''
	}
};